"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { Suspense, useEffect } from "react";
import { analytics } from "@/lib/analytics/posthog-client";

function PostHogPageView(): null {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    try {
      if (pathname && analytics && typeof analytics.capture === "function") {
        let url = window.origin + pathname;
        if (searchParams.toString()) {
          url = `${url}?${searchParams.toString()}`;
        }
        analytics.capture("$pageview", {
          $current_url: url,
        });
      }
    } catch (error) {
      console.error("PostHog page view capture error:", error);
    }
  }, [pathname, searchParams]);

  return null;
}

// Wrap in Suspense to avoid useSearchParams from de-opting the whole app into client-side rendering
export default function SuspendedPostHogPageView() {
  return (
    <Suspense fallback={null}>
      <PostHogPageView />
    </Suspense>
  );
}
